<div class="field-divider-container">
  <div class="field-divider-row"></div>
  <span class="field-divider-text">{{ title | translate }}</span>
  <div class="field-divider-row"></div>
</div>

<ng-content></ng-content>
